<div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--page">
    <vb-spinner size="xl" label="Loading lots"></vb-spinner>
</div>

<div *ngIf="!isLoading">
    <!-- breadcrumb area start -->
    <vb-breadcrumb-one
        [currentUserId]="currentUserId"
        [heroTitle]="true">
        <vb-auction-summary headingActions [auction]="auction" />
    </vb-breadcrumb-one>
    <!-- breadcrumb area end -->

    <!-- shop area start -->
    <section class="tp-shop-area pb-120">
        <div class="container-fluid">
            <!-- Auction facts band — replaces the retired right-hand info
                 rail; the lot list below gets the full page width. The band
                 owns its own Hide/Show header: the breadcrumb above is sticky,
                 so a toggle projected up there stayed pinned to the viewport
                 long after the band had scrolled away. -->
            <vb-auction-info-band
                *ngIf="auction"
                class="lot-info-band"
                [collapsible]="true"
                [collapsed]="infoBandHidden"
                (collapsedChange)="infoBandHidden = $event"
                [state]="auctionBandState"
                [startsAt]="auction.fromDatetime"
                [firstLotClosesAt]="
                    auction.firstLotCloseTime || auction.toDatetime
                "
                [endsAt]="auction.toDatetime"
                [bpPct]="auction.buyerPremium"
                [proxyBidding]="auction.isProxyBiddingEnabled"
                [showTermsLink]="!!auction.termsConditions"
                [paymentMethods]="paymentMethodLabels"
                [descriptionHtml]="auctionDescriptionHtml"
                [pickupAddressLine1]="pickupAddressLine1"
                [pickupAddressLine2]="pickupAddressLine2"
                [directionsUrl]="pickupDirectionsUrl"
                [pickupMethods]="pickupMethods"
                (termsClicked)="openTerms()">
            </vb-auction-info-band>

            <!-- search + jump-to-lot row start -->
            <div class="lot-search-row">
                <vb-search
                    #searchBar
                    class="lot-search-row__search"
                    placeholder="Search for lots in this auction"
                    ariaLabel="Search for lots in this auction"
                    [delegateSearch]="true"
                    (search)="onSearch($event)" />
                <!-- Grid/list toggle — hidden while the compact view is
                     active (≤639px): compact is an automatic view, not a
                     blocked choice. -->
                <div class="tp-shop-top-tab tp-tab" *ngIf="!compactView">
                    <ul class="nav nav-tabs">
                        <li class="nav-item" role="presentation">
                            <button
                                [ngClass]="{
                                    'nav-link': true,
                                    active: activeTab === 'grid'
                                }"
                                (click)="handleActiveTab('grid')">
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16.3327 6.01341V2.98675C16.3327 2.04675 15.906 1.66675 14.846 1.66675H12.1527C11.0927 1.66675 10.666 2.04675 10.666 2.98675V6.00675C10.666 6.95341 11.0927 7.32675 12.1527 7.32675H14.846C15.906 7.33341 16.3327 6.95341 16.3327 6.01341Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M16.3327 15.18V12.4867C16.3327 11.4267 15.906 11 14.846 11H12.1527C11.0927 11 10.666 11.4267 10.666 12.4867V15.18C10.666 16.24 11.0927 16.6667 12.1527 16.6667H14.846C15.906 16.6667 16.3327 16.24 16.3327 15.18Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M7.33268 6.01341V2.98675C7.33268 2.04675 6.90602 1.66675 5.84602 1.66675H3.15268C2.09268 1.66675 1.66602 2.04675 1.66602 2.98675V6.00675C1.66602 6.95341 2.09268 7.32675 3.15268 7.32675H5.84602C6.90602 7.33341 7.33268 6.95341 7.33268 6.01341Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M7.33268 15.18V12.4867C7.33268 11.4267 6.90602 11 5.84602 11H3.15268C2.09268 11 1.66602 11.4267 1.66602 12.4867V15.18C1.66602 16.24 2.09268 16.6667 3.15268 16.6667H5.84602C6.90602 16.6667 7.33268 16.24 7.33268 15.18Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button
                                [ngClass]="{
                                    'nav-link': true,
                                    active: activeTab === 'list'
                                }"
                                (click)="handleActiveTab('list')">
                                <svg
                                    width="16"
                                    height="15"
                                    viewBox="0 0 16 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15 7.11108H1"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M15 1H1"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M15 13.2222H1"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                        </li>
                    </ul>
                </div>
                <vb-lot-jump [auctionId]="auctionId" />
            </div>
            <!-- Filter, sort, and auto-hide controls -->
            <div class="lot-toolbar__controls">
                <div class="lot-toolbar__group">
                    <vb-button
                        [variant]="
                            appliedFilterCount > 0 ? 'primary' : 'secondary'
                        "
                        size="md"
                        [iconLeft]="filterIcon"
                        (clicked)="openFilterModal()">
                        {{ 'AuctionsPage.filtersLabel' | translate }}
                        <span
                            *ngIf="appliedFilterCount > 0"
                            class="lot-filter-badge">
                            {{ appliedFilterCount }}
                        </span>
                    </vb-button>
                    <ng-template #filterIcon>
                        <vb-icon name="filter" [size]="16"></vb-icon>
                    </ng-template>
                    <button
                        *ngIf="appliedFilterCount > 0"
                        type="button"
                        class="lot-filter-clear"
                        (click)="clearFilters()">
                        {{ 'AuctionsPage.clearAllLabel' | translate }}
                    </button>
                </div>
                <vb-select
                    label="Sort"
                    ariaLabel="Sort lots"
                    align="left"
                    placeholder="Default Sorting"
                    [value]="sortBy"
                    [options]="sortingOptions"
                    (valueChange)="sortByFilter($any($event))">
                </vb-select>
                <div class="lot-autohide form-check form-switch p-0">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="AutoHideClosedLots"
                        (change)="autoHideClosedLotsClicked($event)"
                        [checked]="!showClosedLots" />
                    <label class="form-check-label" for="AutoHideClosedLots">
                        {{
                            'AuctionsPage.autoHideClosedLotsLabel'
                                | translate
                        }}
                    </label>
                </div>
            </div>
            <!-- search + jump-to-lot row end -->

            <div class="tp-shop-main-wrapper">
                <!-- Pagination (top) — hidden while closed lots are
                     hidden (that mode uses "Show more" instead) -->
                <vb-paginator-bar
                    *ngIf="showClosedLots && !isLoading && !unableToLoad && mappedLots.length > 0"
                    variant="top"
                    label="lots"
                    [dense]="isMobile"
                    [current]="pageNo"
                    [total]="paginate.totalPages ?? 0"
                    [totalItems]="paginate.totalItems ?? 0"
                    [perPage]="pageSize"
                    [perPageOptions]="pageSizeOptions"
                    (pageChange)="onPageChange($event)"
                    (perPageChange)="setPageSize($event)">
                </vb-paginator-bar>
                <!-- Content-area spinner for subsequent loads (sort, filter,
                     tab toggle, pagination). Holds the outgoing grid's height
                     so the document doesn't shorten and clamp the reader's
                     scroll position (--page is the first-render fallback;
                     the measured inline min-height replaces it). -->
                <div
                    *ngIf="isContentLoading"
                    class="vb-spinner-box lot-content-spinner"
                    [class.vb-spinner-box--page]="!contentHoldHeight"
                    [style.minHeight.px]="contentHoldHeight">
                    <div class="lot-content-spinner__sticky">
                        <vb-spinner size="l" label="Loading lots"></vb-spinner>
                    </div>
                </div>
                <!-- when loading complete, show relevant screen -->
                <div
                    #lotItems
                    *ngIf="!isContentLoading"
                    class="tp-shop-items-wrapper tp-shop-item-primary">
                    <!-- Unable to load, something went wrong -->
                    <div
                        *ngIf="unableToLoad"
                        class="cartmini__empty text-center min-height-30">
                        <img
                            src="/assets/img/product/cartmini/empty-cart.png"
                            alt="empty-cart-img" />
                        <h4>
                            Something went wrong, unable to load Lots!
                        </h4>
                    </div>
                    <!-- if no item in product  -->
                    <div
                        *ngIf="!unableToLoad && mappedLots.length === 0 && !isLoadingMore && !refillPending"
                        class="cartmini__empty text-center min-height-30">
                        <img
                            src="/assets/img/product/cartmini/empty-cart.png"
                            alt="empty-cart-img" />
                        <!-- Closed auction with "Auto-hide closed lots" on:
                             every lot is hidden by the toggle (filters can't
                             reveal anything either), so "no lots" would
                             mislead — say the auction closed and offer to
                             reveal the results. -->
                        <ng-container *ngIf="emptyBecauseAuctionClosed">
                            <h4>
                                {{
                                    'AuctionsPage.auctionClosedEmpty'
                                        | translate
                                }}
                            </h4>
                            <vb-button
                                variant="secondary"
                                size="md"
                                (clicked)="viewClosedLots()">
                                {{
                                    'AuctionsPage.viewClosedLots' | translate
                                }}
                            </vb-button>
                        </ng-container>
                        <h4
                            *ngIf="
                                !emptyBecauseAuctionClosed &&
                                appliedFilterCount === 0
                            ">
                            No Lots available!
                        </h4>
                        <ng-container
                            *ngIf="
                                !emptyBecauseAuctionClosed &&
                                appliedFilterCount > 0
                            ">
                            <h4>
                                {{
                                    'AuctionsPage.noLotsMatchFilters'
                                        | translate
                                }}
                            </h4>
                            <vb-button
                                variant="secondary"
                                size="md"
                                (clicked)="clearFilters()">
                                {{
                                    'AuctionsPage.clearFiltersLabel'
                                        | translate
                                }}
                            </vb-button>
                        </ng-container>
                    </div>
                    <!-- Lots -->
                    <div
                        *ngIf="!unableToLoad && mappedLots.length > 0"
                        class="row infinite-container"
                        [class.gx-3]="effectiveTab === 'grid'"
                        [class.lot-card-list]="effectiveTab === 'list'">
                        <div
                            *ngFor="let lot of mappedLots; trackBy: trackByLot"
                            [@lotRow]="
                                hidingLotIds.has(lot.auctionLotsId || '')
                                    ? 'hidden'
                                    : 'visible'
                            "
                            (@lotRow.done)="onLotRowAnimDone(lot, $event)"
                            [attr.data-auction-lot-id]="lot.auctionLotsId"
                            class="mb-3 d-flex flex-column col-12"
                            [class.col-md-6]="effectiveTab === 'grid'"
                            [class.col-xl-4]="effectiveTab === 'grid'">
                            <vb-lot-card
                                class="flex-fill"
                                [lot]="lot"
                                [auction]="mappedAuction"
                                [viewMode]="effectiveTab"
                                [currentUserId]="currentUserId || null"
                                [userHasBid]="userHasBidOn(lot)"
                                [countdownValue]="countdownTracker.countdowns[lot.auctionLotsId || ''] || null"
                                [biddingEnded]="isLotBiddingEnded(lot)"
                                [graceMs]="graceMs"
                                [isLotSelected]="lot.auctionLotsId === auctionLotsId"
                                [bidLoading]="bidLoadingByLot[lot.auctionLotsId || ''] || false"
                                watchlistAriaLabel="Toggle watchlist"
                                (watchlistUpdated)="onWatchlistUpdated($event)"
                                (bidPlaced)="onQuickBidPlaced(lot)"
                                (customBidPlaced)="onCustomBidPlaced(lot, $event)"
                                (bidRounded)="onBidRounded()"
                                (loadingComplete)="handleLoadingComplete()">
                            </vb-lot-card>
                        </div>
                    </div>
                    <!-- Pagination (bottom) -->
                    <vb-paginator-bar
                        *ngIf="showClosedLots"
                        variant="bottom"
                        label="lots"
                        [dense]="isMobile"
                        [current]="pageNo"
                        [total]="paginate.totalPages ?? 0"
                        [totalItems]="paginate.totalItems ?? 0"
                        [perPage]="pageSize"
                        (pageChange)="onPageChange($event)">
                    </vb-paginator-bar>
                    <!-- Hide-closed mode grows the list in place -->
                    <div
                        *ngIf="!showClosedLots && hasMoreLots"
                        class="d-flex justify-content-center my-3">
                        <vb-button
                            variant="secondary"
                            size="md"
                            [iconRight]="showMoreIcon"
                            [loading]="isLoadingMore"
                            [disabled]="isLoadingMore"
                            (clicked)="showMoreLots()">
                            {{
                                'AuctionsPage.showMoreLotsLabel'
                                    | translate
                            }}
                        </vb-button>
                        <ng-template #showMoreIcon>
                            <vb-icon
                                name="chevDown"
                                [size]="16"></vb-icon>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- shop area end -->

    <vb-lot-filter-modal
        [open]="filterModalOpen"
        [draft]="filterDraft"
        [matchCount]="filterMatchCount"
        [totalCount]="filterTotalCount"
        [categories]="filterCategories"
        [categoryCounts]="filterCategoryCounts"
        (draftChange)="onFilterDraftChange($event)"
        (apply)="onFilterApply()"
        (closed)="onFilterClosed()">
    </vb-lot-filter-modal>

    <!-- Bid confirmation (library dialog, same as lot details) -->
    <vb-bid-confirm-dialog
        [open]="confirmDialogOpen"
        [amount]="pendingBidAmount"
        [bpPct]="auction?.buyerPremium || 0"
        (confirmed)="onBidConfirmed($event)"
        (cancelled)="onBidCancelled()" />

    <!-- Terms & conditions (opened from the info band) -->
    <vb-dialog
        [open]="termsOpen"
        title="Terms and Conditions"
        (closed)="termsOpen = false">
        <div class="lot-terms-body" [innerHTML]="termsHtml"></div>
        <vb-button
            dialogFooter
            variant="secondary"
            [fullWidth]="true"
            (clicked)="termsOpen = false">
            Close
        </vb-button>
    </vb-dialog>
</div>
